import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import Modal from './ui/Modal';

const ConfirmationDialog = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    title = "Confirm Action",
    message = "Are you sure you want to proceed?",
    confirmText = "Delete",
    cancelText = "Cancel",
    type = "danger" // danger, warning, info
}) => {
    if (!isOpen) return null;

    const getButtonColors = () => {
        switch (type) {
            case 'danger':
                return 'bg-red-600 hover:bg-red-700 focus:ring-red-500';
            case 'warning':
                return 'bg-yellow-600 hover:bg-yellow-700 focus:ring-yellow-500';
            default:
                return 'bg-blue-600 hover:bg-blue-700 focus:ring-blue-500';
        }
    };

    const getIconColor = () => {
        switch (type) {
            case 'danger':
                return 'text-red-600';
            case 'warning':
                return 'text-yellow-600';
            default:
                return 'text-blue-600';
        }
    };

    return (
        <Modal onClose={onClose} scrimTestId="confirm-dialog" cardClassName="p-6 animate-in fade-in zoom-in duration-200">
                {/* Header */}
                <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center gap-3">
                        <div className={`p-2 rounded-full bg-white/[0.06] ${getIconColor()}`}>
                            <AlertTriangle size={24} />
                        </div>
                        <h3 className="text-lg font-semibold text-white">
                            {title}
                        </h3>
                    </div>
                    <button
                        onClick={onClose}
                        className="text-pai-faint hover:text-white transition-colors"
                    >
                        <X size={20} />
                    </button>
                </div>

                {/* Message */}
                <div className="mb-6">
                    <p className="text-pai-secondary leading-relaxed">
                        {message}
                    </p>
                </div>

                {/* Actions.

                    Delete stage (#387): Cancel used to carry a SOLID `bg-white`
                    alongside `text-pai-secondary` (white at .75 alpha) — white
                    text on a white pill, i.e. invisible at rest, and only legible
                    once `hover:bg-white/[0.07]` swapped the background for a dark
                    one. That solid fill is a migration leftover: the legacy class
                    was a `bg-white dark:bg-gray-700` pair, and dropping the
                    `dark:` half (the design system is dark-only) left the LIGHT
                    half behind. Every other secondary button in the product uses a
                    low-alpha white wash; this was the only survivor of that shape
                    (grepped). Both buttons now use the design-system tokens, so
                    the pair shares one height/radius/type scale and Cancel can
                    never depend on hover for contrast. */}
                <div className="flex gap-3 justify-end">
                    <button
                        onClick={onClose}
                        data-testid="confirm-dialog-cancel"
                        className="pai-btn-secondary"
                    >
                        {cancelText}
                    </button>
                    <button
                        onClick={onConfirm}
                        data-testid="confirm-dialog-confirm"
                        className={`pai-btn text-white ${getButtonColors()}`}
                    >
                        {confirmText}
                    </button>
                </div>
        </Modal>
    );
};

export default ConfirmationDialog;